define('AwaLabs.ShareCart', [
    'ShareCart.Button.View',
    'ShareCart.Cart.View',
    'ShareCart.Model',
    'Backbone',
    'Utils'
], function (
    ShareCartButtonView,
    ShareCartCartView,
    ShareCartModel,
    Backbone,
    Utils
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var cart = container.getComponent('Cart');
            var model;
            var params;

            if (cart) {
                cart.addChildViews(cart.CART_VIEW, {
                    'Cart.Summary': {
                        'ShareCart.Button': {
                            childViewIndex: 10,
                            childViewConstructor: function childViewConstructor() {
                                return new ShareCartButtonView({
                                    container: container,
                                    cart: cart
                                });
                            }
                        }
                    }
                });
                cart.addChildView('ShareCart.Cart', function addChildView() {
                    return new ShareCartCartView({
                        container: container,
                        cart: cart,
                        model: model
                    });
                });
                cart.on('beforeShowContent', function beforeShowContent() {
                    params = Utils.parseUrlOptions(Backbone.history.fragment);
                    if (params && params.hash) {
                        model = new ShareCartModel();
                        model.fetch({
                            data: {
                                hash: params.hash
                            }
                        });
                    }
                    return model;
                });
            }
        }
    };
});
